export const checksums = {
  "pages": "97rXTe2TVA",
  "articles": "BeZoPl25wB",
  "categories": "QNOt47KSiD",
  "pageSlugs": "qmp2DiEeMr",
  "blogSlugs": "pCT9cRoJDR"
}

export const tables = {
  "pages": "_content_pages",
  "articles": "_content_articles",
  "categories": "_content_categories",
  "pageSlugs": "_content_pageSlugs",
  "blogSlugs": "_content_blogSlugs",
  "info": "_content_info"
}

export default {
  "pages": {
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "block": "json"
    }
  },
  "articles": {
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "block": "json"
    }
  },
  "categories": {
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json"
    }
  },
  "pageSlugs": {
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json"
    }
  },
  "blogSlugs": {
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json"
    }
  },
  "info": {
    "fields": {}
  }
}